
// sessionStorage.setItem("popup-products", "no");

$('.modal-dialog').click(function (e) {
    e.stopPropagation();
});

// $("#modal-product").click(function() {
//   $("#modal-product").css("display", "none");
//   sessionStorage.setItem("popup-products", "yes");
//   // $("#product-recommendations-cart").css("display", "block");
//   // slick();
// });

// $("#btn-product-modal").click(function(){
// 	$("#modal-product").css("display", "none");
//     sessionStorage.setItem("popup-products", "yes"); 
//   // $("#product-recommendations-cart").css("display", "block");
// //   slick();
// });


$("#omitir").click(function() {
//   slick();
  //$("#modal-product").css("display", "none");
  	sessionStorage.setItem("popup-products", "yes");
  // $("#product-recommendations-cart").css("display", "block");
});

// if( sessionStorage.getItem("popup-products") == "yes"){
//   $("#modal-product").css("display", "none");
//   // $("#product-recommendations-cart").css("display", "block");
// // //   slick();
// }else{
// 	$("#modal-product").css("display", "flex");
// }


// function slick() {
//   if(window.innerWidth <= 991){
//     $('.product-recommendations-cart').slick({
//         infinite: true,
//         arrows: false,
//         speed: 300,
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         dots: true,
//         autoplaySpeed: 4000,
//         pauseOnHover: true,
//         autoplay: true,
//         centerMode: true,
//         responsive: [
//           {
//             breakpoint: 1024,
//             settings: {
//               slidesToShow: 2,
//               slidesToScroll: 1,
//               infinite: true,
//               dots: true,
//               arrows: false,
//               centerMode: true,
//               autoplay: true
//             }
//           },
//           {
//             breakpoint: 600,
//             settings: {
//               slidesToShow: 2,
//               slidesToScroll: 1,
//               dots: true,
//               arrows: false,
//               centerMode: true,
//               autoplay: true,
//             }
//           }
//         ]
//       });
//   }
// }


function showCustomModal() {
  document.getElementById('uniqueLoadingModal').style.display = 'block';
}

function hideCustomModal() {
  document.getElementById('uniqueLoadingModal').style.display = 'none';
}


// (async ()=> {

//   // Tarjetero

//   const gifProductID = 7988925268162;
//   // const validationPrice = 39900;
//   const validationPrice = 1;

//   try{
    
//     showCustomModal();

//     const currentCart = await fetch("/cart.json");
//     const dataCurrentCart = await currentCart.json();

//     console.log('Data Current Cart', dataCurrentCart);
//     if(dataCurrentCart){

//       const totalPrice = dataCurrentCart.total_price;
//       console.log('Total Price: ', totalPrice);
      
      
//       const result = dataCurrentCart.items.filter((item) => item.product_id === gifProductID);
//       if(result && result.length > 0){

//         console.log('Ya existe en el carrito el producto gratis.');

//         console.log(result);
//         result.map((item) => {
//           if(item.quantity >= 1){
//             hideCustomModal();
//             $("#modal-product").remove();
//             console.log('SI');            
//           }
//         });

//         if(dataCurrentCart.items.length === 1){
//           console.log('Entra');
          
//           const action = document.querySelector('[data-action="remove"]');
//           if(action){ 
//             action.click();
//           }
//         }

//         if(dataCurrentCart.items.length > 0 && totalPrice < validationPrice){
//           const action = document.querySelector('[data-action="remove"]');
//           if(action){ 
//             action.click();
//           }
//         }
        
//       }else {
        
//         showCustomModal();
     
//         // const condition = dataCurrentCart.items.some((item) => item.final_price >= validationPrice);
//         const condition = dataCurrentCart.total_price >= validationPrice;

//         console.log('Condicion: ', condition);
        
//         const formData = {
//           'items': [{
//            'id': 44731485061314,
//            'quantity': 1
//            }]
//          };
        
//         if(condition){
//           console.log('Ejecutando la petición...');
          
//           await fetch(window.Shopify.routes.root + 'cart/add.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(formData)
//           })
//           .then(response => {
//             console.log(response);
//             if(response.ok === true){
//               window.location.reload();
//             }
//             return response.json();
//           })
//           .catch((error) => {
//             console.error('Error:', error);
//           });
//         }
//         // $("#modal-product").css("display", "block");
//       }
      
//     }
    
//   }catch (err) {
//     console.log(err);
//   } finally {
//     hideCustomModal(); // Ocultar el modal cuando termine la solicitud
//   }
// })();


/** 
 * Función para agregar productos al carrito cuando hay regalo gratis según los parámetros.
*/

/*(async ()=> {  

  const gifProductID = 8089433440450; //Bolso
  const freeProduct2VariantID = 45161992945858; // Bolso
  const validationPrice = 59900;

  try{

    showCustomModal();
    const currentCart = await fetch("/cart.json");
    const dataCurrentCart = await currentCart.json();

    console.log('Data Current Cart', dataCurrentCart);
    if(dataCurrentCart){

      const totalPrice = dataCurrentCart.total_price;
      console.log('Total Price: ', totalPrice);
      

      const total = dataCurrentCart.items.reduce((sum, item) => {
        // Verificar si el item.id es diferente de 45161992945858
        if (item.id !== 45161992945858) {
          // Sumar el final_price al acumulador
          return sum + item.final_line_price;
        }
        return sum; // Si el ID coincide, ignorar el item para la suma
      }, 0);
      
      const condition = total >= validationPrice ? true: false;

      if(condition === false){
        const deleteItem = document.querySelector('[data-id-product="8089433440450"]');
        console.log(deleteItem);
        
        if(deleteItem){
          deleteItem.querySelector('.cart__meta .cart__remove .text-link').click();
        }        
      }

      const result = dataCurrentCart.items.filter((item) => item.product_id === gifProductID);
      if(result && result.length > 0){
        console.log(result);
        result.map((item) => {
          if(item.quantity >= 1){
            //$("#modal-product").remove();
            console.log('SI');            
          }
        });
        
      }else{
        
        showCustomModal();
     
        // const condition = dataCurrentCart.items.some((item) => item.final_price >= validationPrice);

        const total = dataCurrentCart.items.reduce((sum, item) => {
          // Verificar si el item.id es diferente de 45161992945858
          if (item.id !== 45161992945858) {
            // Sumar el final_price al acumulador
            return sum + item.final_line_price;
          }
          return sum; // Si el ID coincide, ignorar el item para la suma
        }, 0);
        
        const condition = total >= validationPrice ? true: false;

        console.log(`La suma total es ${total}`);
        console.log(`¿Es mayor o igual que validationPrice? ${condition}`);
        // const condition = dataCurrentCart.total_price >= validationPrice ? true : false;  

        console.log('Condicion: ', condition);
        
        const formData = {
          'items': [{
           'id': freeProduct2VariantID,
           'quantity': 1
           }]
         };
        
        if(condition){
          console.log('Ejecutando la petición...');
          
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            console.log(response);
            if(response.ok === true){
              window.location.reload();
            }
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
        // $("#modal-product").css("display", "block");
      }
      
    }
    
  }catch (err) {
    console.log(err);
  } finally {
    hideCustomModal(); // Ocultar el modal cuando termine la solicitud
  }
})();*/